import { render } from "./BranchesManagement.vue?vue&type=template&id=314dd582&scoped=true"
import script from "./BranchesManagement.vue?vue&type=script&lang=js"
export * from "./BranchesManagement.vue?vue&type=script&lang=js"

import "./BranchesManagement.vue?vue&type=style&index=0&id=314dd582&lang=css"
import "./BranchesManagement.vue?vue&type=style&index=1&id=314dd582&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314dd582"]])

export default __exports__